import { UserDto } from '../main';

export class DownloadFileDto {
  id: number;
  fileName: string;
  size: number;
}

export class FileInfoDto {

  id: number;
  fileName: string;
  filePath: string;
  size: number;
  createdAt: Date;
  mimetype: string;
  uploadedById: number;
  uploadedBy: UserDto;
  usage: string;
  isPrivate: boolean;
}

export class MimetypeDto {
  id: number;
  mimetype: string;
}
